import moment from 'moment';
import 'moment/locale/ru';
import Pikaday from 'pikaday/pikaday';
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['input', 'container', 'selected']

  connect() {
    moment.locale('ru')

    this.initPikaday(this)
  }

  initPikaday(parent) {
    new Pikaday({
      format:  'dddd, DD MMMM',
      field: parent.containerTarget,
      container: parent.element,
      firstDay: 1,
      minDate: moment().toDate(),
      defaultDate: moment(parent.inputTarget.value, 'DD/MM/YYYY').toDate(),
      setDefaultDate: true,
      showDaysInNextAndPreviousMonths: true,
      enableSelectionDaysInNextAndPreviousMonths: true,
      i18n: {
        previousMonth : 'Предыдущий месяц',
        nextMonth     : 'Следующий месяц',
        months        : ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
        weekdays      : ['Воскресенье','Понедельник','Вторник','Среда','Четверг','Пятница','Суббота'],
        weekdaysShort : ['Вс','Пн','Вт','Ср','Чт','Пт','Сб']
      },
      onSelect: function() {
        parent.selectedTarget.textContent = this.toString(),
        parent.inputTarget.value = this.getMoment().format('DD/MM/YYYY')
        parent.inputTarget.dispatchEvent(new Event('change'))
      }
    })
  }
}
